import React from "react";
import { Link } from "react-router-dom";

const CityMaster = () => {
  // ── Dummy data ──
  const cities = [
    {
      id: 1,
      city: "Mumbai",
      state: "Maharashtra",
      country: "India",
      status: "Active",
    },
    {
      id: 2,
      city: "Los Angeles",
      state: "California",
      country: "USA",
      status: "Inactive",
    },
    {
      id: 3,
      city: "Toronto",
      state: "Ontario",
      country: "Canada",
      status: "Active",
    },
  ];

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* ── Page Title ─────────────────────────────── */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">City List</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="/">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">City List</li>
              </ol>
            </div>
          </div>
        </div>

        {/* ── “Add City” Button ──────────────────────── */}
        <div className="row mb-3">
          <div className="col-12 text-end">
            <Link to="/city-add" className="btn btn-primary">
              + Add City
            </Link>
          </div>
        </div>

        {/* ── City Table ─────────────────────────────── */}
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>City</th>
                        <th>State</th>
                        <th>Country</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cities.map((c, i) => (
                        <tr key={c.id}>
                          <td>{i + 1}</td>
                          <td>{c.city}</td>
                          <td>{c.state}</td>
                          <td>{c.country}</td>
                          <td>
                            <span
                              className={`badge ${
                                c.status === "Active"
                                  ? "bg-success"
                                  : "bg-danger"
                              }`}
                            >
                              {c.status}
                            </span>
                          </td>
                           <td>
                            <div className="d-flex gap-2">
                              <a href="#!" className="btn btn-light btn-sm">
                                <i className="fa-solid fa-eye fs-16"></i>
                              </a>
                              <a
                                href="#!"
                                className="btn btn-soft-primary btn-sm"
                              >
                                <i className="fa-solid fa-pencil fs-16"></i>
                              </a>
                              <a
                                href="#!"
                                className="btn btn-soft-danger btn-sm"
                              >
                                <i className="fa-solid fa-trash fs-16"></i>
                              </a>
                            </div>
                          </td>
                        </tr>
                      ))}
                      {cities.length === 0 && (
                        <tr>
                          <td colSpan="6" className="text-center">
                            No data found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="card-footer text-end">
                <small className="text-muted">
                  Total Cities: {cities.length}
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CityMaster;
